import { React, useEffect, useState } from "react";

import { ComboBox } from "../../../components/ReactAria/ComboBox.js";
import { MyCheckbox } from "../../../components/ReactAria/Checkbox.js";
//API
import { getConfig } from "../../../api/apiSetUp.js";
//Redux
import { useDispatch } from "react-redux";
import { modifyFilterList } from "../../../page/FilterPage/FilterSlice.js";
import { modifyFilterStatementList } from "../../../page/FilterPage/FilterSlice.js";


export const RegionFilter = (props) => {
  let { genreList, className, focusSection } = props;

  let [checked, setChecked] = useState([]);
  let [checkedId, setCheckedId] = useState([]);
  let [filterStatement, setFilterStatement] = useState("");

  let [countryList, setCountryList] = useState([]);
  let [listLoading, setListLoading] = useState(true);
  let [listError, setListError] = useState(false);

  let quick_region_list = [
    { region: "Asia (Region)", id:1 },
    { region: "Africa (Region)", id:2 },
    { region: "Europe (Region)", id:3 },
    { region: "North America (Region)", id:4},
    { region: "South America (Region)", id:5},
  ];

  useEffect(() => {
    async function getCountryList() {
      try {
        const response = await getConfig("getConfigCountry");
        const collator = new Intl.Collator(undefined, { sensitivity: "base" });
        let unique_country_name = [];
        let format_response = response
          .map((item) => {
            return { ...item, item_name: item.english_name };
          })
          .sort((a, b) => collator.compare(a.item_name, b.item_name))
          .filter((item) => {
            if (!unique_country_name.includes(item.item_name)) {
              unique_country_name.push(item.item_name);
              return true;
            } else {
              return false;
            }
          });
        setCountryList(format_response);
        setListError(false);
      } catch (err) {
        setListError(true);
        console.log(err);
      }
      setListLoading(false);
    }
    getCountryList();
  }, []);

  const handleUnCheckAll = () => {
    setChecked([]);
  };

  useEffect(() => {
    handleUnCheckAll();
  }, [genreList]);

  //Update Filter List
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      modifyFilterList({
        field: "region",
        payload: checked,
      })
    );
    setFilterStatement(`(${checked.length}) ` + checked.join(", ") + " ");
  }, [checked]);
  //Update Statement List
  useEffect(() => {
    dispatch(
      modifyFilterStatementList({
        field: "region",
        payload: filterStatement,
      })
    );
  }, [filterStatement]);

  return (
    <div
      className={`${className} ${
        focusSection == className ? "filter_active" : ""
      }`}
    >
      <div className="region_filter_content">
        <div className="region_filter_list_wrapper">
          {listLoading ? (
            <h3>Loading</h3>
          ) : listError ? (
            <h3>Error 404</h3>
          ) : (
            <ComboBox
              list_name="region_filter"
              label_name="Country"
              selection_mode="multiple"
              list_of_items={countryList}
              setChecked={setChecked}
              checked={checked}
              outsider_list={quick_region_list.map((item) => item.region)}
            />
          )}
        </div>
        <div className="region_filter_quick_list">
          <div className="region_filter_quick_list_title">
            or Pick by Region
          </div>
          <div className="region_filter_quick_list_wrapper">
            {quick_region_list.map((item) => (
              <MyCheckbox
                key={item.region}
                children={item.region}
                setChecked={setChecked}
                checked={checked}
                childrenId={item.id}
                checkedId={checkedId}
                setCheckedId={setCheckedId}
              />
            ))}
          </div>
        </div>
      </div>
      <div
        className={`region_filter_checked_display ${
          checked.length == 0 ? "hidden" : ""
        }`}
      >
        <p>You have selected:</p>
        <span>{filterStatement}</span>
        <div className="unchecked_all_btn" onClick={handleUnCheckAll}>
          <svg className="svg-icon" viewBox="0 0 20 20">
            <path d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"></path>
          </svg>
          <div>Reset</div>
        </div>
      </div>
    </div>
  );
};
